import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { useCurrentOrganizationStore } from '@/stores/currentOrganization'
import { useOrganizationStore } from '@/stores/organization'
import { useAuthStore } from '@/stores/auth'
import { collection, getDocs } from 'firebase/firestore'
import { db } from '@/firebase'

export async function organizationGuard(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) {
  const authStore = useAuthStore()
  
  // Se for o único usuário, tem acesso total
  const usersRef = collection(db, 'users')
  const usersSnapshot = await getDocs(usersRef)
  if (usersSnapshot.size === 1) {
    return next()
  }

  // Para outros casos, verifica organização
  const currentOrganizationStore = useCurrentOrganizationStore()
  const organizationStore = useOrganizationStore()

  // Se já temos uma organização selecionada, continua
  if (currentOrganizationStore.currentOrganization) {
    console.log('[Organization Guard] Organização já selecionada:', currentOrganizationStore.currentOrganization.id)
    return next()
  }

  try {
    // Tenta carregar a organização salva
    const savedOrg = await currentOrganizationStore.loadSavedOrganization()
    if (savedOrg) {
      console.log('[Organization Guard] Carregou organização salva:', savedOrg.id)
      return next()
    }

    // Se não tiver organização salva, tenta carregar a padrão
    const defaultOrg = await currentOrganizationStore.loadDefaultOrganization()
    if (defaultOrg) {
      console.log('[Organization Guard] Carregou organização padrão:', defaultOrg.id)
      return next()
    }

    // Se não tiver nenhuma organização, tenta carregar as organizações
    await organizationStore.fetchOrganizations()
    
    // Se tem organizações mas nenhuma selecionada, seleciona a primeira
    if (organizationStore.organizations.length > 0) {
      const firstOrg = organizationStore.organizations[0]
      console.log('[Organization Guard] Selecionando primeira organização:', firstOrg.id)
      await currentOrganizationStore.setCurrentOrganization(firstOrg)
      return next()
    }

    // Se não tem nenhuma organização, redireciona para a página de seleção
    console.log('[Organization Guard] Nenhuma organização encontrada')
    return next({ name: 'organizations' })
  } catch (error) {
    console.error('[Organization Guard] Erro:', error)
    return next({ name: 'organizations' })
  }
}
